import http from "@/components/services/http-common";

export const IsValid = () => {
  return http.get("it/eventEnrollments/valid")
}

// object {AttachmentUrl}
export const checkIn = (payload) => {
  return http.post("it/eventEnrollments", payload)
}

export const error500 = () => {
  return http.get("ItLabs/error500")
}